export function maskNumber(input) {
  return input?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function maskPhoneNumber(value) {
  // Remove all non-digit characters
  if (!value) {
    return '';
  }
  const digits = value.replace(/\D/g, '');

  // Split into groups
  const match = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

  if (!match) return value;

  let formatted = '';

  if (match[1]) {
    formatted = '(' + match[1];
  }

  if (match[1] && match[1].length === 3) {
    formatted += ')';
  }

  if (match[2]) {
    formatted += ' ' + match[2];
  }

  if (match[3]) {
    formatted += '-' + match[3];
  }

  return formatted;
}

export function unmaskPhoneNumber(maskedValue) {
  if (!maskedValue) return null;

  return maskedValue.replace(/\D/g, '');
}

export const maskCurrency = (input) => {
  input = input.toString();
  if (input) {
    let value = input.replace(/\D/g, '');
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return value;
  }
  return input;
};

export const unmaskCurrency = (maskedValue) => {
  if (maskedValue) {
    const digitsOnly = maskedValue.replace(/\D/g, '');
    const originalNumber = parseFloat(digitsOnly);
    return originalNumber;
  } else {
    return '';
  }
};
